module.exports = __webpack_public_path__ + "static/adeleye-e65ae1541fcce91e2eaebfadd0fb0b8a.jpg";